export enum KeyCodes {
  Enter = 13
}